import React from "react";
// @mui icons
//import FacebookIcon from "@mui/icons-material/Facebook";
//import XIcon from "@mui/icons-material/X";
//import GitHubIcon from "@mui/icons-material/GitHub";
//import YouTubeIcon from "@mui/icons-material/YouTube";
import { XIcon, FacebookIcon } from "react-share";
// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/favicon.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Kunta.live",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkunta.live",
    },
    {
      icon: <XIcon />,
      link: "https://x.com/intent/post?url=https%3A%2F%2Fkunta.live&text=Kunta.live",
    },
  ],
  menus: [
    {
      name: "taustaa",
      items: [
        { name: "tietoa", href: "/information" },
        { name: "tavoite", href: "/target" },
        { name: "aikataulut", href: "/schedule" },
      ],
    },
    {
      name: "resurssit",
      items: [{ name: "tampereen yliopisto", href: "https://tuni.fi/" }],
    },
    {
      name: "tuki",
      items: [
        { name: "ota yhteyttä", href: "/contact" },
        { name: "ohjeet", href: "/instructions" },
        { name: "ilmoita virheet", href: "/bugs" },
        { name: "ehdota muutosta", href: "/contact" },
      ],
    },
    {
      name: "Lait",
      items: [
        { name: "käyttöehdot", href: "/termsofuse" },
        { name: "tietosuoja", href: "/gdpr" },
        { name: "lisenssit", href: "license" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Kunta.live by{" "}
      <MKTypography
        component="a"
        href="https://kunta.live"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Osmo Leppäniemi
      </MKTypography>
      .
    </MKTypography>
  ),
};
